<template>
  <aside class="menu">
    <img src="../../assets/logo.svg" class="image logo" alt="Actlocate">
<!--    <p class="menu-label">Exhibits</p>-->
    <ul class="menu-list">
      <li v-for="(territory,key) in filteredTerritories" :key="key">
        <a href="#" @click="selectTerritory(territory.localityId, $event)" :class="{ 'is-active': selectedTerritory.id === territory.id  }">
          <span class="has-text-primary-inverse" v-if="selectedTerritory.id === territory.id && isLocked"><font-awesome-icon icon="lock"></font-awesome-icon></span>
          <span class="has-text-primary-inverse" v-else-if="selectedLocationTerritory.id === territory.id && isLocked"><font-awesome-icon icon="location-arrow"></font-awesome-icon></span>
          {{ territory.name }}
        </a>
      </li>
    </ul>
    <p class="menu-label">Tag: {{ tagId }}</p>
    <ul class="menu-list">
      <li>
        <a href="#" @click="signOut($event)"><font-awesome-icon icon="sign-out-alt"></font-awesome-icon>&nbsp;Sign Out</a>
      </li>
    </ul>
    <!--<p class="menu-label">Zóna: {{ territoryId }}</p>-->
  </aside>
</template>

<script>
/**
 * Copyright (c) 2019. Filip Conka <filip@conka.pro>
 */
import { mapGetters } from 'vuex'

export default {
  name: 'Menu',
  computed: {
    ...mapGetters('territories', {
      territories: 'getTerritories',
      currentTerritoryId: 'getCurrentTerritoryId',
      currentLocationTerritoryId: 'getCurrentLocationTerritoryId',
      isLocked: 'isLocked'
    }),
    ...mapGetters('tag', {
      tagId: 'getTagId',
      territoryId: 'getTerritoryId'
    }),
    selectedTerritory () {
      if (this.currentTerritoryId === null) {
        return {
          id: -1,
          name: null
        }
      }

      return this.territories[this.currentTerritoryId]
    },
    selectedLocationTerritory () {
      if (this.currentLocationTerritoryId === null) {
        return {
          id: -1,
          name: null
        }
      }

      return this.territories[this.currentLocationTerritoryId]
    },
    filteredTerritories () {
      let filtered = {}
      console.log(Object.keys(this.territories))
      for (let key of Object.keys(this.territories)) {
        console.log(this.territories[key])
        if (this.territories[key].configuration.showOnMenu) {
          filtered[key] = this.territories[key]
        }
      }
      return filtered
    }
  },
  methods: {
    selectTerritory (id, event) {
      if (this.currentTerritoryId !== id) {
        event.preventDefault()
        this.$store.dispatch('territories/selectTerritory', id)
      } else {
        this.unlock()
      }
    },
    unlock () {
      this.$store.dispatch('territories/unlockTerritory')
    },
    signOut (event) {
      event.preventDefault()
      this.$store.dispatch('tag/logOut').then(() => location.reload())
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/setup/colors";
  @import "~bulma/sass/utilities/all";

  aside.menu {
    position: sticky;
    overflow: visible;
    top: 0;
    background: none;
    height: 100vh;
    padding-top: 8em;
    padding-right: 2rem;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 999em;
      height: 100%;
      background: linear-gradient(0deg, #fff, #f5f5fa);
    }

    .logo {
      padding-right: 2rem;
      padding-bottom: 4rem;
    }

    &>* {
      z-index: 100;
      position: relative;
    }
  }
</style>
